<template>
  <div class="videointerview">
    <div class="menu">
      <router-link
        v-for="item in menu"
        class="item"
        exact
        :key="item.name"
        :to="item.to">{{ $tr(item.name) }}</router-link>
    </div>
    <router-view/>
  </div>
</template>
<script>

  export default {
    name: 'vacancy-videointerview-navigation',
    data () {
      return {
        menu: [
          {
            to: {
              name: 'vacancy_video_base'
            },
            name: 'vacancy.preferences.settings.general_new',
          },
          {
            to: {
              name: 'vacancy_video_groups'
            },
            name: 'vacancy.videoInterview.tabs.groups',
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.videointerview {
  .menu {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #d7d7d7;

    .item {
      font-size: 16px;
      padding: 12px 20px;
      white-space: nowrap;
      cursor: pointer;
      color: inherit;

      &.router-link-exact-active {
        padding-bottom: 9px;
        border-bottom: 3px solid $green;
      }
    }
  }
}
</style>
